document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header.header");
  
  // Check if mega menu should be enabled based on theme setting
  const desktopNavStyle = header?.getAttribute('data-desktop-nav-style');
  if (desktopNavStyle !== 'mega_menu') {
    // Don't initialize mega menu if drawer is selected
    return;
  }
  
  const buttons = document.querySelectorAll(".header-shortlink");
  const navigation = document.querySelector(".header-shortlinks");
  const megaMenus = document.querySelectorAll(".megamenu-container");
  
  let activeMenu = null;
  let hoverTimeout = null;
  let isInHoverZone = false;
  
  function showMegaMenu(menuTitle) {
    // If this menu is already active, don't re-render
    if (activeMenu === menuTitle) {
      // Just clear any pending hide timeout
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      return;
    }
    
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      hoverTimeout = null;
    }
    
    // Only hide other menus, not if we're switching from one to another
    const previousMenu = activeMenu;
    hideAllMenus();
    
    const megaMenu = document.querySelector(`.megamenu-container[tag="${menuTitle}"]`);
    const button = document.querySelector(`.header-shortlink[data-megamenu="${menuTitle}"]`);
    
    if (megaMenu && button) {
      activeMenu = menuTitle;
      
      // Add the megamenu-open class only if not already present
      if (!document.body.classList.contains("megamenu-open")) {
        // Use requestAnimationFrame to ensure smooth transition
        requestAnimationFrame(() => {
          document.body.classList.add("megamenu-open");
          
          // Then show the specific menu after the body class is applied
          requestAnimationFrame(() => {
            button.classList.add("active");
            megaMenu.style.display = "grid";
            megaMenu.classList.add("show", "active");
          });
        });
      } else {
        // If body already has the class, just show the menu directly
        button.classList.add("active");
        megaMenu.style.display = "grid";
        megaMenu.classList.add("show", "active");
      }
    }
  }
  
  function hideAllMenus() {
    if (activeMenu === null) return; // Already hidden
    
    megaMenus.forEach(menu => {
      menu.classList.remove("show", "active");
      menu.style.display = "none";
    });
    
    buttons.forEach(button => {
      button.classList.remove("active");
    });
    
    document.body.classList.remove("megamenu-open");
    activeMenu = null;
  }
  
  function scheduleHide() {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
    
    hoverTimeout = setTimeout(() => {
      if (!isInHoverZone) {
        hideAllMenus();
      }
      hoverTimeout = null;
    }, 200);
  }
  
  // Button hover handlers
  buttons.forEach(button => {
    button.addEventListener("mouseenter", function () {
      isInHoverZone = true;
      const menuTitle = button.getAttribute("data-megamenu");
      showMegaMenu(menuTitle);
    });
    
    button.addEventListener("mouseleave", function () {
      isInHoverZone = false;
      
      const menuTitle = button.getAttribute("data-megamenu");
      const megaMenu = document.querySelector(`.megamenu-container[tag="${menuTitle}"]`);
      
      if (megaMenu) {
        setTimeout(() => {
          if (!isInHoverZone) {
            scheduleHide();
          }
        }, 50);
      } else {
        scheduleHide();
      }
    });
  });
  
  // Mega menu hover handlers
  megaMenus.forEach(menu => {
    menu.addEventListener("mouseenter", function () {
      isInHoverZone = true;
      
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
      
      const menuTitle = this.getAttribute("tag");
      // Only show if it's not already the active menu
      if (activeMenu !== menuTitle) {
        showMegaMenu(menuTitle);
      }
    });
    
    menu.addEventListener("mouseleave", function () {
      isInHoverZone = false;
      scheduleHide();
    });
  });
  
  // Global mouse tracking for safety
  document.addEventListener("mousemove", function(e) {
    const isOverButton = Array.from(buttons).some(button => {
      const rect = button.getBoundingClientRect();
      return e.clientX >= rect.left && e.clientX <= rect.right && 
             e.clientY >= rect.top && e.clientY <= rect.bottom;
    });
    
    const isOverMegaMenu = Array.from(megaMenus).some(menu => {
      if (menu.style.display === "none") return false;
      const rect = menu.getBoundingClientRect();
      return e.clientX >= rect.left && e.clientX <= rect.right && 
             e.clientY >= rect.top && e.clientY <= rect.bottom;
    });
    
    isInHoverZone = isOverButton || isOverMegaMenu;
  });
  
  // Click outside to close
  document.addEventListener("click", function(e) {
    if (!header.contains(e.target)) {
      hideAllMenus();
    }
  });
  
  // ESC key to close
  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && activeMenu) {
      hideAllMenus();
    }
  });
}); 
